import { render, staticRenderFns } from "./RequirementsPayment.vue?vue&type=template&id=56551632"
import script from "./RequirementsPayment.vue?vue&type=script&lang=js"
export * from "./RequirementsPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports